import type { QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from "@tanstack/react-router";

import { pageTitle } from "@/i18n/title";
import { NotFoundPage } from "@/notFound/NotFoundPage";
import { VersionWatch } from "@/shell/VersionWatch";

export type RouterContext = { queryClient: QueryClient };

export const Route = createRootRouteWithContext<RouterContext>()({
  // Pages without a head of their own (the /conectar flow) show the product.
  head: () => pageTitle(),
  notFoundComponent: NotFoundPage,
  component: () => (
    <>
      <HeadContent />
      <VersionWatch />
      <Outlet />
    </>
  ),
});
